export const LoyaltyLevel = (json: IPointLoyaltyLevel): IPointLoyaltyLevelModel => {
	const { points_multiplier, points_threshold, updated_at, created_at, ...rest } = json

	return {
		...rest,
		pointsThreshold: points_threshold,
		pointsMultiplier: points_multiplier,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}
